export default __webpack_public_path__ + "static/media/SCLP.792fa55a.svg";